export default __webpack_public_path__ + "static/media/valley2.f69ae7ea.jpg";